<img style="width:39px; height: 39px;" class="video-close" (click)="onClose()" src="./assets/img/close.png" alt="close button"/>
<iframe #iframeVideo width="100%" height="100%" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

